import { render, staticRenderFns } from "./PowerschoolImport.vue?vue&type=template&id=57380b1f"
import script from "./PowerschoolImport.vue?vue&type=script&lang=js"
export * from "./PowerschoolImport.vue?vue&type=script&lang=js"
import style0 from "./PowerschoolImport.vue?vue&type=style&index=0&id=57380b1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports